import React, { useEffect, useContext } from 'react';
import { Box, CircularProgress, Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useMediaQuery } from 'react-responsive';

import useYext from './hooks/useYext';
import LocationSelector from './components/LocationSelector';
import ScanResults from './components/ScanResults';
import MobileTitle from '../../customUI/MobileTitle';
import { storeContext } from '../provider/Provider';
import { yextActions } from '../../store/yext-reducer';
import useStyles from './Yext.style';
import NoLocations from './components/NoLocations';

const Yext = () => {
  const classes = useStyles();
  const isPhone = useMediaQuery({ query: '(max-width: 768px)' });
  const { state, dispatch } = useContext(storeContext);
  const {
    snackbarOpen,
    snackbarMessage,
    isFetchingLocations,
    error,
    loadLocations,
    closeSnackbar,
    currentLocation,
    locations,
  } = useYext();

  useEffect(() => {
    dispatch({
      type: yextActions.SET_CURRENT_LOCATION,
      payload: { currentLocation: null },
    });
    dispatch({
      type: yextActions.SET_SCAN_RESULTS,
      payload: { scanResults: null },
    });
    
    loadLocations();
  }, [state.websiteSwitch?.currentWebsite, dispatch, loadLocations]);

  // Clear scan results when location changes
  useEffect(() => {
    dispatch({
      type: yextActions.SET_SCAN_RESULTS,
      payload: { scanResults: null },
    });
  }, [currentLocation?.id, dispatch]);

  if (isFetchingLocations) {
    return (
      <div className={isPhone ? '' : classes.wrapper}>
        <div className={isPhone ? '' : classes.card}>
          <Box className={classes.loadingContainer}>
            <CircularProgress />
          </Box>
        </div>
      </div>
    );
  }

  if (!locations || locations.length === 0) {
    return (
      <NoLocations />
    );
  }

  return (
    <div className={isPhone ? '' : classes.wrapper}>
      <div className={isPhone ? '' : classes.card}>
        <div className={isPhone ? '' : classes.card__wrapper}>
          {isPhone ? (
            <MobileTitle title="Yext PowerListings" />
          ) : (
            <div className={classes.heading}>Yext PowerListings</div>
          )}
          
          <Box className={classes.contentSection}>
            <LocationSelector />
            <ScanResults />
          </Box>

          {/* Snackbar for notifications */}
          <Snackbar
            open={snackbarOpen}
            autoHideDuration={6000}
            onClose={closeSnackbar}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          >
            <Alert onClose={closeSnackbar} severity={error ? 'error' : 'success'}>
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </div>
      </div>
    </div>
  );
};

export default Yext;
